<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
      <h4 class="">Home</h4>
      <p class="font-size-18">Welcome back {{ user?.firstName }}! Here’s what’s going on today.</p>

      <app-messages-dashboard></app-messages-dashboard>

      <app-announcements-dashboard></app-announcements-dashboard>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
      <app-calendar-dashboard></app-calendar-dashboard>
    </div>
  </div>
</div>
